import {DictListType} from "./dictListType.model";

export class OkvedType {
  okved?: Array<DictListType> = undefined;
  okved2?: Array<DictListType> = undefined;
}
